import { InjectionToken } from '@angular/core';
import { TelemetryService } from './telemetry.service';

export const TELEMETRY_SERVICE = new InjectionToken<TelemetryService>('TELEMETRY_SERVICE');
